import React from 'react';
import { Link } from 'react-router-dom';
import { useEmbeddedNavigation } from '../hooks/useEmbeddedMode.js';
import { cn } from '../ui/cn.js';

const FOOTER_LINKS = [
  { to: '/assistance', label: 'Assistance' },
  { to: '/confidentialite', label: 'Politique de confidentialité' }
];

export default function SiteFooterLinks({ className, centered = false }) {
  const { toEmbeddedPath } = useEmbeddedNavigation();

  return (
    <div
      className={cn(
        'flex flex-wrap gap-x-4 gap-y-2 text-sm text-ptcm-muted',
        centered ? 'justify-center text-center' : 'justify-start',
        className
      )}
    >
      {FOOTER_LINKS.map((link) => (
        <Link
          key={link.to}
          to={toEmbeddedPath(link.to)}
          className="transition-colors hover:text-ptcm-ink hover:underline"
        >
          {link.label}
        </Link>
      ))}
    </div>
  );
}
